import {FormFieldBase, FormFieldBaseOptions} from './form-field-base';

export interface FormFieldInputOptions<T = any> extends FormFieldBaseOptions<T> {
    type?: string;
    style?: string;
    limit?: number;
    /**
     * The `appFormat` directive is used to format input values as currency or numbers.
     * Note: This directive should only be applied to input elements with type `text`.
     * Using it on `type="number"` inputs or other input types may cause unexpected behavior.
     * The output format will always be a number.
     */
    format?: 'currency' | 'number';
}

export class FormFieldInput<T = any> extends FormFieldBase<T> {
    controlType = 'input';
    type: string;
    style: string;
    format?: 'currency' | 'number';

    constructor(options: FormFieldInputOptions<T> = {}) {
        super(options);
        this.controlType = options.controlType || this.controlType || 'input';
        this.type = options.type || '';
        this.style = options.style || '';
        this.limit = options.limit || null;
        this.format = options.format;
    }
}
